import { BasicClient } from '@/utils/httpClient'

export default class Mfa {
  client
  constructor() {
    this.client = new BasicClient()
  }

  sendEmailVerificationCode() {
    return this.client.exec(
      `/v2/auth-mod/mfa/generateEmailVerificationCode`,
      'POST'
    )
  }

  sendVerificationCode() {
    return this.client.exec(`/v2/auth-mod/mfa/generateAuthCode`, 'POST')
  }

  validateAuthCode(code) {
    const params = { code: code }
    return this.client.exec(`/v2/auth-mod/mfa/validateAuthCode`, 'POST', params)
  }
  validateAuthCodeFromEmail(code) {
    const params = { code: code }
    return this.client.exec(
      `/v2/auth-mod/mfa/validateEmailVerificationCode`,
      'POST',
      params
    )
  }

  getProfilePreference() {
    return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'GET')
  }

  saveProfilePreference(profileId, mfaId) {
    return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'POST', {
      profileId,
      mfaId
    })
  }

  deleteProfilePreference(profileId, mfaId) {
    return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'DELETE', {
      profileId,
      mfaId
    })
  }

  getResendStatus() {
    return this.client.exec(`/v2/auth-mod/mfa/resendStatus`, 'GET')
  }

  //Autogestion/Config de MFA
  getMfaConfig() {
    return this.client.exec(`/v2/auth-mod/mfa/userPreference`, 'GET')
  }
  saveMfaConfig(password) {
    const data = { password }; 

    return this.client.exec(`/v2/auth-mod/mfa/userPreference`, 'POST', data);
  }
  deleteMfaConfig() {
    return this.client.exec(`/v2/auth-mod/mfa/userPreference`, 'DELETE')
  }
}
